import { dayKeyInTimeZone } from './timezone';
/**
 * 「这条记录是什么时候真的进系统的」——两个时间的对照（CR-033）。
 *
 * 客户的原话是：「现在我意识到我这个系统所有记录，除了打卡。其他都是基于自选时间对吧？
 * 这类软件不是应该制作成自动记录时间嘛？」
 *
 * **系统一直在自动记时间**，只是界面上从来没显示：
 *
 * | 记录 | 系统记的 | 人能选的 |
 * |---|---|---|
 * | 打卡 | `receivedAt`（服务端）+ `occurredAt`（设备） | 没有 |
 * | 隐蔽工程 | `serverAt` | 没有（`capturedAt` 来自相机） |
 * | 日报 | `createdAt` | `workDate` |
 * | 采购 | `createdAt` | `purchasedAt` |
 * | 附件 | `uploadedAt` | 没有（`takenAt` 来自拍摄） |
 *
 * 真正能自选的只有日报的 `workDate` 和采购的 `purchasedAt`，而这两个**必须保留** ——
 * 周五晚上买的料周一才录、忘了写的日报第二天补，强制用提交时刻等于把这些记成假账。
 * 所以做法是：两个时间都显示，**对不上就标出来**，让审的人自己判断。
 *
 * 这里只有判断，没有展示 —— 展示在 `apps/web/src/features/records/RecordTime.tsx`。
 */
/**
 * 两个时刻差几分钟（向下取整，不分先后）。
 *
 * 用于「设备说它是这个时候拍的，服务器是那个时候收到的」这种对照。
 */
export function driftMinutes(a, b) {
    return Math.floor(Math.abs(b.getTime() - a.getTime()) / 60_000);
}
/**
 * 提示阈值：两个时间差超过这么多分钟就值得在界面上说一句。
 *
 * 10 分钟这个数原本硬编码在考勤页的 `PunchRow` 里（`driftMinutes > 10`）。
 * 收成常量是为了四类记录一个口径 —— 否则日报按 10 分钟、隐蔽工程按 30 分钟，
 * 同一份数据在两页上一个标一个不标，看的人只会以为界面坏了。
 *
 * 10 分钟的依据：手机时钟和服务器差几分钟是常态（网络校时有延迟），
 * 差十分钟以上通常意味着**离线补传**或者设备时钟被改过。
 */
export const DRIFT_NOTICE_MINUTES = 10;
/** 差得够大，值得提示。差值本身仍然要显示出来，让人自己判断是补传还是时钟不准 */
export function isNoticeableDrift(a, b) {
    return driftMinutes(a, b) > DRIFT_NOTICE_MINUTES;
}
/**
 * 人填的业务日期和系统记录时刻**不是同一个自然日**。
 *
 * @param businessDay 人填的日期，`YYYY-MM-DD`（日报的 workDate、采购的 purchasedAt）
 * @param recordedAt  系统记下的时刻（createdAt）
 * @param timeZone    工地时区 —— **必须按工地时区比**，按浏览器时区比会让
 *                    晚上提交的记录在管理员那边整片变成「补录」
 *
 * 返回 true 不代表有错：周五买料周一录很正常。它只是说「这条是事后填的」，
 * 审的人有权知道这件事。
 */
export function isBackdated(businessDay, recordedAt, timeZone) {
    return dayKeyInTimeZone(recordedAt, timeZone) !== businessDay.slice(0, 10);
}
//# sourceMappingURL=record-time.js.map